// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__XhvSS","box":"WorkspacesBox_box__2siEb","node":"WorkspacesBox_node__16vYG"};